<template>
	<main-page :user="user" color="orange">
		<template v-slot:title>
			PROFILE
		</template>

		<div class="container">
			<div class="row content">
				<table class="w-100">
					<template v-for="(question, i) in profileQuestions">
						<tr :key="`1-${i}`">
							<td rowspan="3" class="pt-4 px-3 text-lg">{{ i + 1 }}.</td>
							<td colspan="2">
								<!-- <div class="mt-3 mb-2 text-left">{{ i + 1 }}. {{ question.prompt.text }}</div> -->
								<div class="mt-3 mb-0 text-left text-md _600">{{ question.strength.name }}</div>
								<div class="mb-2 text-left">{{ question.strength.desc }}</div>
							</td>
						</tr>
						<tr :key="`2-${i}`">
							<td style="width: 70px;">
								<div class="text-extra-muted text-left">Score</div>
							</td>
							<td><div class="text-extra-muted text-left">Reasoning</div></td>
						</tr>
						<tr :key="`3-${i}`">
							<td style="width: 70px;">
								<div v-if="question.response.score != null" class="score text-left">
									{{ question.response.score }}
								</div>
								<div
									v-if="question.response.score == null"
									class="text-extra-muted text-center text-lg"
								>
									N/A
								</div>
							</td>
							<td class="text-left">
								<div v-if="question.response.reasoning != null">{{ question.response.reasoning }}</div>
								<div v-if="question.response.reasoning == null" class="text-extra-muted text-lg">
									N/A
								</div>
							</td>
						</tr>
						<tr :key="`4-${i}`">
							<td v-if="i != profileQuestions.length - 1" colspan="3">
								<hr class="mb-0" />
							</td>
							<td v-if="i == profileQuestions.length - 1" colspan="3"><div class="mb-4"></div></td>
						</tr>
					</template>
				</table>
				<div class="w-100 text-left">
					<div class="d-flex flex-row">
						<div class="d-flex flex-column b-r pr-2 mr-3"></div>
						<div class="flex-grow d-flex flex-column"></div>
					</div>
				</div>
			</div>
		</div>

		<template v-slot:footer>
			<div class="colp-6 text-right">
				<a class="btn btn-si-secondary" @click="goBack">Back</a>
			</div>
		</template>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";

import ProfileService from "@/services/ProfileService";
import ProgramService from "@/services/ProgramService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import _ from "lodash";

export default {
	name: "Profile",

	props: ["user"],

	components: { MainPage },

	data() {
		return {
			fs: fs,

			loading: true,
			userID: null,
			profile: null,
		};
	},

	created() {
		this.userID = this.$route.params.userID;
		if (!this.userID) {
			this.userID = this.user.id;
		}
		this.assignmentID = this.$route.params.assignmentID;

		this.loadProfile();
	},

	computed: {
		profileQuestions() {
			let questions = [];

			if (!this.profile) {
				return [];
			}

			_.each(this.profileConfig.questions, (pq) => {
				let response = _.find(this.profile.responses, { item_id: pq.id });
				let strength = _.find(this.profileConfig.strengths, { id: pq.strength_id });

				let question = {
					prompt: pq,
					response: response,
					strength: strength,
				};

				questions.push(question);
			});

			questions = _.orderBy(
				questions,
				(q) => {
					return q.response.score;
				},
				"desc"
			);

			return questions;
		},
	},

	methods: {
		loadProfile() {
			let call = null;
			if (this.userID) {
				call = ProfileService.getProfile(this.userID, this.assignmentID);
			} else {
				call = ProfileService.getUserProfile(this.assignmentID);
			}

			BB.props({
				program: ProgramService.getContextProgram(),
				profile: call,
			})
				.then((r) => {
					this.loading = false;
					this.profile = r.profile.data;
					this.program = r.program.data;
					this.profileConfig = this.program.profile_config;
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to load profile", e);
				});
		},

		goBack() {
			this.$router.go(-1);
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.score {
	font-size: 32px;
	line-height: 1;
}
</style>
